/**
 * Convert string or array of classes to object
 * @param classes
 * @returns {{}}
 */
export const objectifyClasses = function (classes) {
  if (typeof classes === 'string') {
    return classes.split(' ')
      .reduce((acc, c) => {
        acc[c] = true;
        return acc;
      }, {});
  }

  if (Array.isArray(classes)) {
    const result = {};
    classes.forEach(c => {
      result[c] = true;
    });

    return result;
  }

  return classes;
}
